const environment = process.env.REACT_APP_ENV;

export const getDocUrl = (externalUrl) => {
    switch (environment) {
        case "prod":
            return `https://commondataelements.ninds.nih.gov/sites/nindscde/files/${externalUrl}`;
        case "test":
            return `https://nindscde.deltasigmastats9.com/sites/default/files/${externalUrl}`;
        default:
            return `https://nindscde.deltasigmastats9.com/sites/default/files/${externalUrl}`;
    }
};
